const cieColorMatch: Array<[number, number, number]> = [
    [0.0014, 0.0000, 0.0065], [0.0022, 0.0001, 0.0105], [0.0042, 0.0001, 0.0201],
    [0.0076, 0.0002, 0.0362], [0.0143, 0.0004, 0.0679], [0.0232, 0.0006, 0.1102],
    [0.0435, 0.0012, 0.2074], [0.0776, 0.0022, 0.3713], [0.1344, 0.0040, 0.6456],
    [0.2148, 0.0073, 1.0391], [0.2839, 0.0116, 1.3856], [0.3285, 0.0168, 1.6230],
    [0.3483, 0.0230, 1.7471], [0.3481, 0.0298, 1.7826], [0.3362, 0.0380, 1.7721],
    [0.3187, 0.0480, 1.7441], [0.2908, 0.0600, 1.6692], [0.2511, 0.0739, 1.5281],
    [0.1954, 0.0910, 1.2876], [0.1421, 0.1126, 1.0419], [0.0956, 0.1390, 0.8130],
    [0.0580, 0.1693, 0.6162], [0.0320, 0.2080, 0.4652], [0.0147, 0.2586, 0.3533],
    [0.0049, 0.3230, 0.2720], [0.0024, 0.4073, 0.2123], [0.0093, 0.5030, 0.1582],
    [0.0291, 0.6082, 0.1117], [0.0633, 0.7100, 0.0782], [0.1096, 0.7932, 0.0573],
    [0.1655, 0.8620, 0.0422], [0.2257, 0.9149, 0.0298], [0.2904, 0.9540, 0.0203],
    [0.3597, 0.9803, 0.0134], [0.4334, 0.9950, 0.0087], [0.5121, 1.0000, 0.0057],
    [0.5945, 0.9950, 0.0039], [0.6784, 0.9786, 0.0027], [0.7621, 0.9520, 0.0021],
    [0.8425, 0.9154, 0.0018], [0.9163, 0.8700, 0.0017], [0.9786, 0.8163, 0.0014],
    [1.0263, 0.7570, 0.0011], [1.0567, 0.6949, 0.0010], [1.0622, 0.6310, 0.0008],
    [1.0456, 0.5668, 0.0006], [1.0026, 0.5030, 0.0003], [0.9384, 0.4412, 0.0002],
    [0.8544, 0.3810, 0.0002], [0.7514, 0.3210, 0.0001], [0.6424, 0.2650, 0.0000],
    [0.5419, 0.2170, 0.0000], [0.4479, 0.1750, 0.0000], [0.3608, 0.1382, 0.0000],
    [0.2835, 0.1070, 0.0000], [0.2187, 0.0816, 0.0000], [0.1649, 0.0610, 0.0000],
    [0.1212, 0.0446, 0.0000], [0.0874, 0.0320, 0.0000], [0.0636, 0.0232, 0.0000],
    [0.0468, 0.0170, 0.0000], [0.0329, 0.0119, 0.0000], [0.0227, 0.0082, 0.0000],
    [0.0158, 0.0057, 0.0000], [0.0114, 0.0041, 0.0000], [0.0081, 0.0029, 0.0000],
    [0.0058, 0.0021, 0.0000], [0.0041, 0.0015, 0.0000], [0.0029, 0.0010, 0.0000],
    [0.0020, 0.0007, 0.0000], [0.0014, 0.0005, 0.0000], [0.0010, 0.0004, 0.0000],
    [0.0007, 0.0002, 0.0000], [0.0005, 0.0002, 0.0000], [0.0003, 0.0001, 0.0000],
    [0.0002, 0.0001, 0.0000], [0.0002, 0.0001, 0.0000], [0.0001, 0.0000, 0.0000],
    [0.0001, 0.0000, 0.0000], [0.0001, 0.0000, 0.0000], [0.0000, 0.0000, 0.0000]
];

interface IColorSystem {
    name: string;                     /* Colour system name */
    xRed: number;
    yRed: number;              /* Red x, y */
    xGreen: number;
    yGreen: number;           /* Green x, y */
    xBlue: number;
    yBlue: number;             /* Blue x, y */
    xWhite: number;
    yWhite: number;           /* White point x, y */
    gamma: number;                    /* Gamma correction for system */
};


export const HDTVColorSystem: IColorSystem = {
    gamma: 0,
    name: "HDTV",
    xBlue: 0.150,
    xGreen: 0.210,
    xRed: 0.670,
    xWhite: 0.3127,
    yBlue: 0.060,
    yGreen: 0.710,
    yRed: 0.330,
    yWhite: 0.3291
    
};

export const CIEColorSystem: IColorSystem = {
    gamma: 0,
    name: "CIE",
    xBlue: 0.1669,
    xGreen: 0.2658,
    xRed: 0.7355,
    xWhite: 0.3333333,
    yBlue: 0.0085,
    yGreen: 0.7243,
    yRed: 0.2645,
    yWhite: 0.333333333
    
};

export let xData: Array<[number, number]> = new Array<[number, number]>();

for (let i = 0, lambda = 360; i < cieColorMatch.length; i++ , lambda += 5) {
    xData.push([lambda, cieColorMatch[i][0]]);
}

export let yData: Array<[number, number]> = new Array<[number, number]>();

for (let i = 0, lambda = 360; i < cieColorMatch.length; i++ , lambda += 5) {
    yData.push([lambda, cieColorMatch[i][1]]);
}

export let zData: Array<[number, number]> = new Array<[number, number]>();

for (let i = 0, lambda = 360; i < cieColorMatch.length; i++ , lambda += 5) {
    zData.push([lambda, cieColorMatch[i][2]]);
}

export function spectrumToXYZ(intensityWavelengths: Array<[number, number]>): [number, number, number] {
    let X: number = 0;
    let Y: number = 0;
    let Z: number = 0;

    let i=0;
    for (const val of intensityWavelengths) {
        const transmittance = Math.pow(10,2-val[1]);
        X += transmittance * cieColorMatch[i][0];
        Y += transmittance * cieColorMatch[i][1];
        Z += transmittance * cieColorMatch[i][2];
        i++;
    }
    const XYZ = (X + Y + Z);
    return [X / XYZ, Y / XYZ, Z / XYZ];
}

// export function xyzToRGB( xc: number, yc: number, zc: number): [number, number, number]{
//     const R = 3.240479*xc + -1.537150*yc + -0.498535*zc;
//     const G = -0.969256*xc + 1.875992*yc + 0.041556*zc;
//     const B = 0.055648*xc + -0.204043*yc + 1.057311*zc;
//     return [R,G,B];
// }

export function xyzToRGB(cs: IColorSystem, xc: number, yc: number, zc: number): [number, number, number] {

    const xr = cs.xRed; const yr = cs.yRed; const zr = 1 - (xr + yr);
    const xg = cs.xGreen; const yg = cs.yGreen; const zg = 1 - (xg + yg);
    const xb = cs.xBlue; const yb = cs.yBlue; const zb = 1 - (xb + yb);

    const xw = cs.xWhite; const yw = cs.yWhite; const zw = 1 - (xw + yw);

    /* xyz . rgb matrix, before scaling to white. */

    let rx = (yg * zb) - (yb * zg); let ry = (xb * zg) - (xg * zb); let rz = (xg * yb) - (xb * yg);
    let gx = (yb * zr) - (yr * zb); let gy = (xr * zb) - (xb * zr); let gz = (xb * yr) - (xr * yb);
    let bx = (yr * zg) - (yg * zr); let by = (xg * zr) - (xr * zg); let bz = (xr * yg) - (xg * yr);

    /* White scaling factors.
    Dividing by yw scales the white luminance to unity, as conventional. */

    const rw = ((rx * xw) + (ry * yw) + (rz * zw)) / yw;
    const gw = ((gx * xw) + (gy * yw) + (gz * zw)) / yw;
    const bw = ((bx * xw) + (by * yw) + (bz * zw)) / yw;

    /* xyz . rgb matrix, correctly scaled to white. */

    rx = rx / rw; ry = ry / rw; rz = rz / rw;
    gx = gx / gw; gy = gy / gw; gz = gz / gw;
    bx = bx / bw; by = by / bw; bz = bz / bw;

    /* rgb of the desired point */

    return [(rx * xc) + (ry * yc) + (rz * zc), (gx * xc) + (gy * yc) + (gz * zc), (bx * xc) + (by * yc) + (bz * zc)];
}

export function constrainRGB(color: [number,number,number]): [number,number,number]
{
    
    let w = 0;
    /* Amount of white needed is w = - min(0, *r, *g, *b) */

    w = (0 < color[0]) ? 0 : color[0];
    w = (w < color[1]) ? w : color[1];
    w = (w < color[2]) ? w : color[2];
    w = -w;

    /* Add just enough white to make r, g, b all positive. */

    if (w > 0) {
        return [color[0]+w, color[1]+w,color[2]+w];     /* Colour modified to fit RGB gamut */
    }

    return color;                         /* Colour within RGB gamut */
}

function gammaCorrect(cs:IColorSystem, c:number):number
{
    let gamma:number;
    let correctedColor:number = c;

    gamma = cs.gamma;

    if (gamma === 0) {
        /* Rec. 709 gamma correction. */
        const cc = 0.018;

        if (correctedColor < cc) {
            correctedColor *= ((1.099 * Math.pow(cc, 0.45)) - 0.099) / cc;
        } else {
            correctedColor = (1.099 * Math.pow(correctedColor, 0.45)) - 0.099;
        }
    } else {
        /* Nonlinear colour = (Linear colour)^(1/gamma) */
        correctedColor = Math.pow(correctedColor, 1.0 / gamma);
    }

    return correctedColor;
}

export function gammaCorrectRGB(cs : IColorSystem,color:[number,number,number]): [number,number,number]
{
    const r = gammaCorrect(cs, color[0]);
    const g = gammaCorrect(cs, color[1]);
    const b = gammaCorrect(cs, color[2]);
    return [r,g,b];
}

export function normRGB(color: [number,number,number]): [number,number,number]{

    const greatest:number = Math.max(color[0], Math.max(color[1], color[2]));

    if (greatest > 0) {
        return [color[0]/greatest, color[1]/greatest, color[2]/greatest];
    }
    return color;
}


export function wavelengthToColor(wavelength:number):string {
        let R;
        let G;
        let B;
        let alpha;
        let colorSpace;
        const wl = wavelength;
        const gamma = 1;
 
 
        if (wl >= 380 && wl < 440) {
            R = -1 * (wl - 440) / (440 - 380);
            G = 0;
            B = 1;
       } else if (wl >= 440 && wl < 490) {
           R = 0;
           G = (wl - 440) / (490 - 440);
           B = 1;   
        } else if (wl >= 490 && wl < 510) {
            R = 0;
            G = 1;
            B = -1 * (wl - 510) / (510 - 490);
        } else if (wl >= 510 && wl < 580) {
            R = (wl - 510) / (580 - 510);
            G = 1;
            B = 0;
        } else if (wl >= 580 && wl < 645) {
            R = 1;
            G = -1 * (wl - 645) / (645 - 580);
            B = 0.0;
        } else if (wl >= 645 && wl <= 780) {
            R = 1;
            G = 0;
            B = 0;
        } else {
            R = 0;
            G = 0;
            B = 0;
        }
 
        // intensty is lower at the edges of the visible spectrum.
        if (wl > 780 || wl < 380) {
            alpha = 0;
        } else if (wl > 700) {
            alpha = (780 - wl) / (780 - 700);
        } else if (wl < 420) {
            alpha = (wl - 380) / (420 - 380);
        } else {
            alpha = 1;
        }
 
        colorSpace = ["rgba(" + (R * 100) + "%," + (G * 100) + "%," + (B * 100) + "%, " + alpha + ")", R, G, B, alpha]
 
        // colorSpace is an array with 5 elements. 
        // The first element is the complete code as a string.  
        // Use colorSpace[0] as is to display the desired color.  
        // use the last four elements alone or together to access each of the individual r, g, b and a channels.  
       
        return colorSpace[0] as string;
        
    }


// WEBPACK FOOTER //
// ./src/colorData.ts